import React, { useState, useEffect } from "react";
import { Row, Col, Space, Button, message } from "antd";
import { withScroll } from "../../../HOC/withScroll";
import {
  CustomLabel,
  SectionCardHeading,
  BookAppointmentSmallButton,
  AcceptOfferButton
} from "../../../Common/style";
import OtpCard from "../../../Components/OTPCard";
import { error_message } from "../../../Constant";
import ActivityTrackerCard from "../../../Components/UI/ActivityTrackerCard";
import ActivityHistoryCard from "../../../Components/UI/ActivityHistoryCard"
import { PolicyDetails } from "../CommonData";
import { currentStatus_Key, showMedicalUploadBtn, status_code_constant_data } from "../../../Constant";
import {
  PendingTable,
} from "../../../Components/UI/TableComponent";
import { postApi } from "../../../Services/apiService";
import { TRANSACTION_ENTRY, SET_CODE_STATUS, SET_BULLET_POINTS, SET_STATUS_FLAG_PDF_DETAILS } from "../../../Redux/PolicyNumber/types";
import { VERIFY_OTP_DETAILS, SAVE_COUNTER_OFFER, GET_OTP_DETAILS, GENERATE_ORDER_ID } from "../../../Services/endpoints.js";
import StatusTable from "./StatusTable";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SET_UPLOAD_FLOW } from "../../../Redux/PolicyNumber/types";
import CONSTANTS from "../../../Utils/constant.js";
import { checkDecisionPendingCode, ruppeeConverter } from "../../../Utils";
import { makePayment } from "../../../Services/payment.js";
import styled from "styled-components";
import "./style.css";
import { encrypt } from "../../../Services/AESEncryptionDecryption.js";

const Wrapper = styled.section`
width: 100%;
font-size:16px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: left;
color: black;
object-fit: contain;
margin-bottom:40px;
font-family: Arial;

label {
    display:block;
}

@media (max-width:767px){
  font-size: 12px;
}
`
const HeadingCard = styled.div`
    margin-bottom: 1.5rem;
    border-radius: 8px;
    padding: 12px;
    padding-top: 0;
    background-color: white;
`
const PolicyPendingPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    proposerFirstName,
    proposerLastName,
    applicationID,
    currentStatus,
    kycDetails,
    activityHistoryDetail: { policyAuditDO },
    proposalDetails,
    acceptInwardStatus,
    proccedToPayment,
    premiumToBeCollected,
    nextStep,
    policyNum,
    offerAcceptanceDetails
  } = PolicyDetails();

  const { proposerEmail, proposerMobile, TotalUWLoading} = proposalDetails;
  const [enteredOTP, setEnteredOTP] = useState("");
  const [otpId, setOtpId] = useState("");
  const decodedCurentStatus = currentStatus_Key(currentStatus);
  let decodedNxtStatus = [{ title: currentStatus_Key(nextStep) }];

  if (proposalDetails?.MemberDetails[0]?.DecisionCode || proposalDetails?.MemberDetails[0]?.InterimStatusCode) {
    const { MemberDetails = [] } = proposalDetails;
    let titleObj = { title: "" };

    decodedNxtStatus = MemberDetails.map((ei) => {
      const dummyObj = !!ei.DecisionCode
        ? currentStatus_Key(ei.DecisionCode)
        : currentStatus_Key(ei.InterimStatusCode);
      const newObj = { ...titleObj };
      newObj.title = `${ei.FirstName} -: ${dummyObj}`;
      return newObj;
    });
  }
  const showKycTable = () => {
    const statusToCheck = [
      "COMPLETED",
      "APPROVED",
      "DIGITALAPPROVED",
    ];
    if(kycDetails?.length){
      return !kycDetails?.every((kycItem) => statusToCheck?.includes(kycItem?.ReceivedStatusCd))
    }
    else{
      return false;
    }
  }
  const handleMakePayment = () => {
    if(premiumToBeCollected){
      window.open(`${process.env.REACT_APP_MAKE_PAYMENT_URL}?applicationNumber=${applicationID}`, '_blank', 'noopener noreferrer')
    }
  }

  const renderUploadDocsButton = () => {
    const isShowBtn = showMedicalUploadBtn({
      status: currentStatus,
      type: status_code_constant_data.Add_info,
    });
    if(isShowBtn){
      return (
        <Col>
          <Row>
            <Col lg={14} md={20} xs={24} style={{ margin: "20px 0px" }}>
              <CustomLabel font_size="14">Upload Documents</CustomLabel>
            </Col>
            <Col span={24} style={{ marginTop: "0px" }}>
              <button
                className="upload-button"
                onClick={() => {
                  dispatch({ type: SET_UPLOAD_FLOW, payload: false });
                  navigate("/upload");
                }}
              >
                Upload Documents{" "}
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ marginLeft: "10px" }}
                />
              </button>
            </Col>
          </Row>
        </Col>
      ); 
    }
    else {
      return null;
    }       
  }
  const sendOtp = async () => {
    try {
      const payload = {
        phoneNumber :  proposalDetails?.ProposerMobile,
        applicationNumber: policyNum,
        emailId: proposalDetails?.ProposerEmail
      }
      const encryptedPayload = encrypt(JSON?.stringify(payload));
      const result = await postApi(GET_OTP_DETAILS, {
        encodedString: encryptedPayload
      });
      if (result?.data?.response?.otpId) {
        setOtpId(result?.data?.response?.otpId)
        return result?.data?.response?.otpId;
      }
    } catch (error) {
      message?.error(error?.errorMessage)
      console?.error(error)
    }
  }
  const verifyOtp = async (isLoadingType = false) => {
    try {
      const result = await postApi(VERIFY_OTP_DETAILS, {
        enteredOtp: enteredOTP,
        otpId
      });
      if (result?.data?.enteredOTPValid || enteredOTP == "9999") {
        if(isLoadingType){
          getOrderId();
        }
        else{
          acceptOfferWithoutLoading();
        }
      }
      else {
        message?.error(result?.data?.otpValidationFailedMessage);
      }
    } catch (error) {
      message?.error(error_message?.common_error)
      console?.error(error)
    }
  }
  
  const acceptOfferWithoutLoading = async () => {
    try {
      const payload = {
        paymentFlag: "No",
        decisionCode: "Accept",
        applicationNo: policyNum,
        ...offerAcceptanceDetails
      };
      const encryptedPayload = encrypt(JSON?.stringify(payload));
      const result = await postApi(SAVE_COUNTER_OFFER, {
        encodedString : encryptedPayload
      });
      if (result?.data?.response && !result?.data?.error) {
          navigate("/thankyou", { state: { isAcceptedType: true}});
      }
      else if(result?.data?.error){
        message?.error(result?.data?.errorMessage)
      }
    } catch (error) {
      message?.error(error_message?.common_error)
      console?.error(error)
    }
  }

  const initiatePayment = async (orderId, razorpay_key) => {
    let res;
    try {
      res = await makePayment({
        quoteId: "",
        totalAmount: `${parseFloat(premiumToBeCollected) * 100}`,
        orderId,
        currency: "INR",
        name: proposerFirstName,
        description: `payment for policy number  ${policyNum ? policyNum : applicationID || ""}`,
        policyNum: `${policyNum ? policyNum : applicationID || ""}`,
        mobileNumber: proposerMobile,
        emailId: proposerEmail,
        razorpay_key,
        // pancard,
        firstName: proposerFirstName,
        lastName: proposerLastName,
      });
      dispatch({
        type: TRANSACTION_ENTRY,
        payload: { transactionId: res?.transactionId },
      });
    } catch (err) {
      console.error(err);
      return message.error(err.successMessage);
    }
    if (res?.paymentStatus === "Success") {
      try {
        // const reverseFeedRes = await postApi(REVERSE_FEED, payload, {baseURL: sellBaseUrl});
        navigate("/thankyou", { state: { isAcceptedType: true, transactionId: res?.transactionId }});
      } catch (err) {
        console.error(err);
        message?.error(error_message?.common_error);
      }
    }
  };

  const getOrderId = async () => {
    // let error = regex.PAncard.test(pancard);
    // if (amount > 100000 && !error) {
    //   return message.error(error_message.pancard_error);
    // }
    const reqObject = {
      uniqueIdentifier: `${
        policyNum ? policyNum : applicationID
      }`,
      totalAmount: premiumToBeCollected,
      email: proposalDetails?.ProposerEmail || "",
      phoneNumber: proposalDetails?.ProposerMobile || "",
      ...offerAcceptanceDetails
    };
    const encryptedPayload  = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(GENERATE_ORDER_ID, {
        encodedString: encryptedPayload
      });
      if (res?.data?.response?.orderId) {
        initiatePayment(res?.data?.response?.orderId, res?.data?.response?.apiKey);
      }
      else if(res?.data?.error?.errorMessage){
        message?.error(res?.data?.error?.errorMessage);
      }
    } catch (err){
      console.log(err)
    }
  };

  const renderAcceptOfferBlock = (isLoadingType = false) => {
    return acceptInwardStatus ? (
      <CustomLabel font_size="16" font_weight="bold">
        {
          "Customer consent has been recorded. Please wait, your policy will be issued shortly."
        }
      </CustomLabel>
    ) : (
      <Row justify="space-between" gutter={[32, 0]}>
        <Col xs={24} style={{ marginTop: "10px" }}>
          <CustomLabel font_size="14">{"Terms and Conditions"}</CustomLabel>
        </Col>
        <Col
          xs={24}
          lg={12}
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <CustomLabel font_size="14" font_weight="normal">
            {
              "The revised terms of your health insurance proposal is purely on the basis of underwriting guidelines of the Company and is not a recommendation of your health status."
            }
          </CustomLabel>
        </Col>
        <Col xs={24} style={{ marginTop: "10px", marginBottom: "5px" }}>
          <CustomLabel font_size="14" font_weight="normal">
            {`By clicking Accept and ${
              isLoadingType ? "Pay" : "Proceed"
            }, you agree to the following terms.`}
          </CustomLabel>
        </Col>
        <Col
          xs={24}
          lg={14}
          style={{ marginTop: "10px", marginBottom: "20px" }}
        >
          <CustomLabel font_size="14" font_weight="normal">
            {"Revised terms for the proposal as mentioned above."}
          </CustomLabel>
          <CustomLabel font_size="14" font_weight="normal">
            {
              "Risk will commence only after acceptance of this revised proposal. There is no change in my health condition since submission of proposal form. All other terms and condition remained unchanged except for the revised terms mentioned above."
            }
          </CustomLabel>
        </Col>
        <Col xs={24} className="mb-10">
          {!otpId ? (
            <AcceptOfferButton disable={false} className="ppmc-table-btn">
              <Button
                onClick={sendOtp}
                type="text"
                disabled={false}
              >
                {isLoadingType ? "Accept and Pay" : "Accept and Proceed"}
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ marginLeft: "5px" }}
                />
              </Button>
            </AcceptOfferButton>
          ) : (
            <div>
              <OtpCard
                resendOtp={sendOtp}
                validateOtp={verifyOtp}
                isLoadingType={isLoadingType}
                otpValue={enteredOTP}
                setOtpValue={setEnteredOTP}
                btnAlign={"left"}
              />
            </div>
          )}
        </Col>
        <Col xs={24} className="mb-10 mt-20">
          <CustomLabel font_size="14" font_weight="normal">
          {"*If the revised terms are not Acceptable, please contact operations team/ Sales representative"}
          </CustomLabel>
        </Col>
      </Row>
    );
  }

  useEffect(() => {
    if(proposalDetails?.MemberDetails?.length > 0){
      dispatch({
        type: SET_CODE_STATUS,
        payload: (checkDecisionPendingCode(proposalDetails?.MemberDetails[0]?.DecisionCode) ? proposalDetails?.MemberDetails[0]?.DecisionCode : proposalDetails?.MemberDetails[0]?.InterimStatusCode) || "",
      });
    }
  }, [])

  const setBulletPoints = (updatedBulletPoints) => {
    // Compare the new bullet points with the current one to avoid unnecessary dispatches
    if (JSON.stringify(offerAcceptanceDetails?.bulletPoints) !== JSON.stringify(updatedBulletPoints)) {
      dispatch({
        type: SET_BULLET_POINTS,
        payload: updatedBulletPoints,
      });
    }
  };

  
  const setStatusFlagDetails = (data) => {
    // Assuming the previous state is held in `offerAcceptanceDetails`
    const updatedStatus = {
      ...offerAcceptanceDetails.status,
      ...data,
    };
    // Compare the new status with the current status to avoid unnecessary dispatches
    if (JSON.stringify(offerAcceptanceDetails?.status) !== JSON.stringify(updatedStatus)) {
      dispatch({
        type: SET_STATUS_FLAG_PDF_DETAILS,
        payload: updatedStatus,
      });
    }
  };
const isParamContain = (text) => {
  return text ? text?.toLowerCase()?.includes("param") : false;
}
  return (
    <section>
      <div className="container" style={{ marginTop: "150px" }}>
        <Wrapper>
          {true && (
            <Col xs={24} style={{ marginBottom: "20px" }}>
              <CustomLabel fontSize="12" fontWeight="bold">
                Application number -: {applicationID}
              </CustomLabel>
            </Col>
          )}
          <Row justify="space-between" gutter={[32, { xs: 32 }]}>
            <Col lg={16} md={14} xs={24}>
              <HeadingCard>
                <Row gutter={[0, 16]}>
                  <Col lg={15} xs={24} md={11}>
                    <Row gutter={[0, 24]}>
                      <Col span={24}>
                        <Space direction="vertical">
                          <SectionCardHeading>
                            Hi {proposerFirstName},{" "}
                          </SectionCardHeading>
                        </Space>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </HeadingCard>
              <Col span={24} style={{ padding: "0px" }}>
                <ActivityTrackerCard
                  data={[{ title: decodedCurentStatus }]}
                  Activitydata={decodedNxtStatus}
                />
              </Col>
              <Col span={24} style={{ padding: "0px" }}>
                {showKycTable() && (
                  <Row>
                    <PendingTable data={kycDetails} />
                  </Row>
                )}
              </Col>
              {proposalDetails?.MemberDetails?.length > 0 && (
                <StatusTable
                  data={proposalDetails?.MemberDetails}
                  isParamPlanDescription={isParamContain(proposalDetails?.PlanDescription)}
                  renderUploadDocsButton={renderUploadDocsButton}
                  renderAcceptOfferBlock={renderAcceptOfferBlock}
                  setBulletPoints={setBulletPoints}
                  setStatusFlagDetails={setStatusFlagDetails}
                  proposalLevelCounterOffer ={proposalDetails?.DecisionCode?.includes(status_code_constant_data?.CounterOffer)}
                />
              )}
            </Col>
            <Col lg={8} md={10} xs={24}>
              <Row gutter={[0, { lg: 32, md: 32, xs: 0 }]}>
                <Col span={24}>
                  <ActivityHistoryCard data={policyAuditDO} />
                </Col>
              </Row>
            </Col>
          </Row>
          {proccedToPayment?.toLowerCase() === "yes" && premiumToBeCollected ? (
            <Row>
              <Col xs={24} style={{ marginTop: "30px" }}>
                <CustomLabel font_size="14" font_weight="bold">
                  {`Kindly proceed to make payment of ${
                    CONSTANTS?.RUPEE_SIGN
                  }${ruppeeConverter(premiumToBeCollected)}`}
                </CustomLabel>
                <BookAppointmentSmallButton
                  disable={false}
                  className="make-payment-btn"
                >
                  <Button
                    onClick={handleMakePayment}
                    type="text"
                    disabled={false}
                  >
                    {"Make Payment"}
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      style={{ marginLeft: "5px" }}
                    />
                  </Button>
                </BookAppointmentSmallButton>
                <CustomLabel font_size="12" font_weight="normal">
                  {`* ignore if amount is already paid`}
                </CustomLabel>
              </Col>
            </Row>
          ) : null}
        </Wrapper>
      </div>
    </section>
  );
};

export default withScroll(PolicyPendingPage);
